import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class WishlistService {
  wishlist:any[] = []
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,private toastrService: ToastrService,) {
    if (isPlatformBrowser(this.platformId)) {

      this.wishlist = JSON.parse(localStorage.getItem('wishlist'))
      if(this.wishlist == null){
        this.wishlist = []
      }
    }
    }

  // addItemToWishList(data: any) {
  //   if (this.CommonService.wishList.length > 0) {
  //     if (this.CommonService.wishList.includes(data)) {
  //       let i = this.CommonService.wishList.indexOf(data)
  //       this.CommonService.wishList.splice(i, 1)
  //     } else {
  //       this.CommonService.wishList.push(data)
  //     }
  //   } else {
  //     this.CommonService.wishList.push(data)
  //   }
  // }


  addItemToWishList(prod: any) {


    if (this.wishlist.length > 0) {
      if (this.wishlist?.includes(prod)) {
        let i = this.wishlist?.indexOf(prod)
        this.wishlist?.splice(i, 1);
        this.toastrService.warning("Vehicle removed from wishlist.")
      } else {
        this.wishlist?.push(prod)
        this.toastrService.success("Vehicle added to wishlist.")
      }
    } else {
      this.wishlist?.push(prod)
      this.toastrService.success("Vehicle added to wishlist.")
    }
        if (isPlatformBrowser(this.platformId)) {
    localStorage.setItem('wishlist',JSON.stringify(this.wishlist))
  }
  }

  getWishlist() {
    if (isPlatformBrowser(this.platformId)) {

    this.wishlist = localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : [];
    return this.wishlist
    }
  }
}
